import React from 'react';
import { Box, Typography, Stack, Button } from '@mui/material';
import {
  ArrowBack as BackIcon,
  AccountBalance as RefundIcon
} from '@mui/icons-material';

import { SaveChangesButton, SubmitForApprovalButton, ResubmitButton, PaidButton, CancelButton } from './commands';

interface RefundEditHeaderProps {
  id: string;
  onBack: () => void;
  onError: (message: string) => void;
}

const RefundEditHeader: React.FC<RefundEditHeaderProps> = ({
  id,
  onBack,
  onError
}) => {
  return (
    <Box sx={{
      backgroundColor: '#ffffff',
      borderBottom: '2px solid #3b82f6',
      p: 1.5
    }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={4}>
          <RefundIcon sx={{ color: '#3b82f6', fontSize: 28 }} />
          <Box>
            <Typography variant="h4" component="h1" fontWeight={600} color="#1e293b">
              Refund Request
            </Typography>
            <Typography variant="body1" color="#64748b">
              Managing refund request #{id}
            </Typography>
          </Box>
        </Box>
        <Stack direction="row" spacing={1} sx={{ ml: 4 }}>
          <Button 
            variant="outlined" 
            startIcon={<BackIcon />}
            onClick={onBack}
            sx={{ 
              minWidth: 120, 
              height: 40, 
              textTransform: 'none',
              fontWeight: 500 
            }}
          >
            Go Back
          </Button>
          <Stack direction="row" spacing={1}>
            <SaveChangesButton onError={onError} />
            <SubmitForApprovalButton onError={onError} />
            <ResubmitButton onError={onError} />
            <CancelButton onError={onError} />
            <PaidButton onError={onError} />
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default RefundEditHeader;
